import { Theme, useTheme, } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Breakpoint, } from '@material-ui/core/styles/createBreakpoints';

/**
 * Be careful using this hook. It only works because the number of
 * breakpoints in theme is static. It will break once you change the number of
 * breakpoints. See https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level
 * Code copied from https://material-ui.com/components/use-media-query/#migrating-from-withwidth and optimized.
 */
export const useWidth = () => {
    const { breakpoints, }: Theme = useTheme();

    return breakpoints.keys.reduceRight((output: Breakpoint | null, key: Breakpoint) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const matches = useMediaQuery(breakpoints.up(key));

        return !output && matches ? key : output;
    }, null) || 'xs';
};
